export default __webpack_public_path__ + "static/media/armada.bd765a41.svg";